module.exports = __webpack_public_path__ + "static/media/snowy-1.f78cba60.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/weather-icons/snowy-1.svg
// module id = 526
// module chunks = 0